// src/components/OverlayLogout.jsx
import React from "react";

const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  zIndex: 9999,
  width: "100vw",
  height: "100vh",
  backgroundColor: "#596169",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  color: "#fff",
  fontSize: "1.5rem",
};



const spinnerStyle = {
  border: "6px solid #f3f3f3",
  borderTop: "6px solid #b71c1c",
  borderRadius: "50%",
  width: "60px",
  height: "60px",
  animation: "spin 1s linear infinite",
};

const OverlayLogout = () => {
  return (
    <div style={overlayStyle}>
      <div style={spinnerStyle} />
      <p style={{ marginTop: "20px" }}>Compte archivé. Déconnexion en cours...</p>
    </div>
  );
};

export default OverlayLogout;
